module.exports = __webpack_public_path__ + "img/trip-logo.92b8f7af.svg";